import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useLanguage, Language } from '../i18n';
export function LanguageSwitcher() {
  const {
    lang
  } = useLanguage();
  const location = useLocation();
  const getPath = (newLang: Language) => {
    const pathParts = location.pathname.split('/');
    pathParts[1] = newLang;
    return pathParts.join('/') || `/${newLang}`;
  };
  const languages: {
    code: Language;
    label: string;
  }[] = [{
    code: 'en',
    label: 'EN'
  }, {
    code: 'ua',
    label: 'UA'
  }, {
    code: 'ru',
    label: 'RU'
  }];
  return <div className="flex items-center gap-2 text-sm font-medium" data-id="element-265">
      <Globe className="w-4 h-4 text-gray-500" data-id="element-266" />
      <div className="flex items-center bg-gray-100 rounded-lg p-1" data-id="element-267">
        {languages.map(({
        code,
        label
      }) => <Link key={code} to={getPath(code)} className={`px-3 py-1 rounded-md transition-all ${lang === code ? 'bg-white text-teal-700 shadow-sm' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-268">
            {label}
          </Link>)}
      </div>
    </div>;
}